import { render } from "./building_documents.vue?vue&type=template&id=e86d0dd6&scoped=true"
import script from "./building_documents.vue?vue&type=script&lang=js"
export * from "./building_documents.vue?vue&type=script&lang=js"

import "./building_documents.vue?vue&type=style&index=0&id=e86d0dd6&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e86d0dd6"]])

export default __exports__